import { Map } from 'immutable';
import get from 'lodash/get';

import * as D from '../deps';

import * as SpecialOffersConstants from './constants';

const INITIAL_VALUES = Object.freeze({
  [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CODE]: '',
  [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_PRODUCTS]: null,
  [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS]: '',
  [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_ERROR_MESSAGE]: '',
  [SpecialOffersConstants.ReducerKeys.CAMPAIGN_COPY]: null,
  [SpecialOffersConstants.ReducerKeys.AUTH_LANDING_PAGE]:
    SpecialOffersConstants.AUTH_LANDING_PAGE_LOGIN,
  [SpecialOffersConstants.ReducerKeys.DELAYED_ACTIVATION]: false,
});

export const INITIAL_STATE = Map(INITIAL_VALUES);

export default D.createReducer(INITIAL_STATE, {
  [SpecialOffersConstants.Actions.RESET_SPECIAL_OFFER]: resetSpecialOffer,
  [SpecialOffersConstants.Actions.UPDATE_REDEMPTION_STATE]: updateSpecialOfferRedemptionState,
  [D.Constants.Api.ApiActions.GET_SPECIAL_OFFER_V2_SUCCESS]: getSpecialOfferSuccess,
  [D.Constants.Api.ApiActions.GET_SPECIAL_OFFER_V2_FAIL]: getSpecialOfferFail,
});

function resetSpecialOffer(state, { payload: { shouldResetCampaignCopy, shouldResetError } }) {
  const changes = {
    [SpecialOffersConstants.ReducerKeys.AUTH_LANDING_PAGE]:
      INITIAL_VALUES[SpecialOffersConstants.ReducerKeys.AUTH_LANDING_PAGE],
  };

  if (shouldResetCampaignCopy) {
    changes[SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_PRODUCTS] =
      INITIAL_VALUES[SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_PRODUCTS];
    changes[SpecialOffersConstants.ReducerKeys.CAMPAIGN_COPY] =
      INITIAL_VALUES[SpecialOffersConstants.ReducerKeys.CAMPAIGN_COPY];
    changes[SpecialOffersConstants.ReducerKeys.DELAYED_ACTIVATION] =
      INITIAL_VALUES[SpecialOffersConstants.ReducerKeys.DELAYED_ACTIVATION];
  }

  if (shouldResetError) {
    changes[SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CODE] =
      INITIAL_VALUES[SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CODE];
    changes[SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS] =
      INITIAL_VALUES[SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS];
    changes[SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_ERROR_MESSAGE] =
      INITIAL_VALUES[SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_ERROR_MESSAGE];
  }

  return state.merge(changes);
}

function updateSpecialOfferRedemptionState(
  state,
  { payload: { specialOfferCode, specialOfferStatus } },
) {
  const oldSpecialOfferCode = state.get(SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CODE);
  const oldSpecialOfferStatus = state.get(SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS);
  return state.merge({
    [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CODE]:
      specialOfferCode !== null ? specialOfferCode : oldSpecialOfferCode,
    [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS]:
      specialOfferStatus !== null ? specialOfferStatus : oldSpecialOfferStatus,
  });
}

function getSpecialOfferSuccess(state, action) {
  const currStatus = state.get(SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS);
  const nextStatus =
    currStatus === SpecialOffersConstants.RedemptionStatus.SUBMITTED_ANONYMOUS
      ? SpecialOffersConstants.RedemptionStatus.SUBMITTED_ANONYMOUS
      : SpecialOffersConstants.REDEEMING;
  if (action.response.specialOfferType === SpecialOffersConstants.OfferTypes.CODE_PRODUCT) {
    const {
      authLandingPage,
      campaignCopy,
      campaignId,
      delayedActivation,
      productGroups,
      specialOfferToken,
    } = action.response;
    return state.merge({
      [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS]: nextStatus,
      [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CODE]: specialOfferToken,
      [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_PRODUCTS]: productGroups,
      [SpecialOffersConstants.ReducerKeys.CAMPAIGN_COPY]: campaignCopy,
      [SpecialOffersConstants.ReducerKeys.AUTH_LANDING_PAGE]: authLandingPage,
      [SpecialOffersConstants.ReducerKeys.DELAYED_ACTIVATION]: delayedActivation,
      [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_ERROR_MESSAGE]: '',
      [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CAMPAIGN_ID]: campaignId,
    });
  }
  return state.merge({
    [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS]: nextStatus,
    [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_PRODUCTS]: action.response.productGroups,
  });
}

function getSpecialOfferFail(state, action) {
  const actionErrorType = get(action, 'error.errorType', '');
  const actionErrorMessage = get(action, 'error.errorMessage', '');
  const specialOfferToken = get(action, 'error.action.content.specialOfferToken', '');
  if (actionErrorType) {
    const errorMessage =
      actionErrorType === SpecialOffersConstants.ErrorCodes.NO_TRIAL_ELIGIBILITY
        ? JSON.parse(actionErrorMessage.replace(/\\/g, ''))
        : actionErrorMessage;
    return state.merge({
      [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_CODE]: specialOfferToken,
      [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_STATUS]: actionErrorType,
      [SpecialOffersConstants.ReducerKeys.SPECIAL_OFFER_ERROR_MESSAGE]: errorMessage,
    });
  }
  return state;
}
